import { Injectable } from '@angular/core';
import { AppSettings } from '../app-settings';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MasipService {

  private adminSelect = new BehaviorSubject<boolean>(false);
  public adminStorage = this.adminSelect.asObservable();

  private userSelect = new BehaviorSubject<boolean>(false);
  public userStorage = this.userSelect.asObservable();

  private apiLoadingSelect = new BehaviorSubject<boolean>(false);
  public apiLoadingStorage = this.apiLoadingSelect.asObservable();

  private apiLoadingGlobalSelect = new BehaviorSubject<boolean>(false);
  public apiLoadingGlobalStorage = this.apiLoadingGlobalSelect.asObservable();

  constructor(private http: HttpClient) { }


  getAdmin() {
    return this.adminSelect.getValue();
  }

  setAdmin(admin: any) {
    this.adminSelect.next(admin);
  }

  getUser() {
    return this.userSelect.getValue();
  }

  setUser(user: any) {
    this.userSelect.next(user);
  }

  getApiLoading() {
    return this.apiLoadingSelect.getValue();
  }

  setApiLoading(loading: any) {
    this.apiLoadingSelect.next(loading);
  }

  getApiLoadingGlobal() {
    return this.apiLoadingGlobalSelect.getValue();
  }

  setApiLoadingGlobal(loading: any) {
    this.apiLoadingGlobalSelect.next(loading);
  }

  getLinesByUser(perPage: number, page: number, fiscal_id: string, ip: number, search?: string, id_groups?: any[], id_profiles?: any[]) {
    let url = AppSettings.API_URI + '/lines?fiscal_id=' + fiscal_id + '&ip=' + ip;
    if (page != 0) {
      url = url + '&page=' + page;
    }
    if (perPage != 0) {
      url = url + '&num=' + perPage;
    }
    if (search) {
      url = url + '&search=' + search;
    }
    if (id_groups) {
      id_groups.forEach((element: any) => {
        url = url + '&id_groups[]=' + element;
      });
    }
    if (id_profiles) {
      id_profiles.forEach((element: any) => {
        url = url + '&id_profiles[]=' + element;
      });
    }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getLinesWithoutProfile(fiscal_id: string, num: number, page:number) {
    let url = AppSettings.API_URI + '/lines/no-profile?fiscal_id=' + fiscal_id;
    if (num > 0) {
      url = url + '&num=' + num;
    }
    if (page > 0) {
      url = url + '&page=' + page;
    }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      }
      )
    );
  }

  getLinesWithoutGroup(fiscal_id: string, num: number, page:number) {
    let url = AppSettings.API_URI + '/lines/no-group?fiscal_id=' + fiscal_id;
    // if (num > 0) {
    //   url = url + '&num=' + num;
    // }
    // if (page > 0) {
    //   url = url + '&page=' + page;
    // }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      }
      )
    );
  }

  getLineServices(phone: string) {
    let url = AppSettings.API_URI + '/lines/services/' + phone;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getBlacklist(phone: string) {
    let url = AppSettings.API_URI + '/blacklist/' + phone;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getWhitelist(phone: string) {
    let url = AppSettings.API_URI + '/whitelist/' + phone;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }


  getFiberByUser(perPage: number = 9, page: number = 1, fiscal_id: string, search?: string) {
    let url = AppSettings.API_URI + '/getUserFiberLines?fiscal_id=' + fiscal_id + '&page=' + page + '&num=' + perPage;
    if (search) {
      url = url + '&search=' + search;
    }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getClients(perPage: number = 9, page: number = 1, search?: string) {
    let url = AppSettings.API_URI + '/users?page=' + page + '&num=' + perPage;
    if (search) {
      url = url + '&search=' + search;
    }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getRules(ip: string, mode: string) {
    let url = AppSettings.API_URI + '/getUserRules?address=' + ip;
    if (mode == 'fiber') {
      url = url + '%2F32';
    }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getQueue(fiscal_id: string, page: number, initialDate: string, endDate: string, search: string, type: string) {
    let url = AppSettings.API_URI + '/getQueue?per_pages=9' + '&page=' + page;
    if (fiscal_id !== '') {
      url = url + '&fiscal_id=' + fiscal_id;
    }
    if (initialDate !== '') {
      url = url + '&initialDate=' + initialDate;
    }
    if (endDate !== '') {
      url = url + '&endDate=' + endDate;
    }
    if (search !== '') {
      url = url + '&search=' + search;
    }
    if (type !== '') {
      url = url + '&type=' + type;
    }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getConfigAdmin() {
    let url = AppSettings.API_URI + '/getConfig';
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  postConfigAdmin(payload: any) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const url = `${AppSettings.API_URI}/updateConfig`;
    return this.http.post<any>(url, payload, formHeaders).pipe(
      map(data => {
        return data;
      }), catchError(err => {
        return of(false);
      })
    );
  }

  postWhitelistQueue(payload: any) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const url = `${AppSettings.API_URI}/AddWhitelistToQueue`;
    return this.http.post<any>(url, payload, formHeaders).pipe(
      map(data => {
        return data;
      }), catchError(err => {
        return of(false);
      })
    );
  }

  postBlacklistQueue(payload: any) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const url = `${AppSettings.API_URI}/AddBlacklistToQueue`;
    return this.http.post<any>(url, payload, formHeaders).pipe(
      map(data => {
        return data;
      }), catchError(err => {
        return of(false);
      })
    );
  }

  postConfigLineQueue(payload: any) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const url = `${AppSettings.API_URI}/AddConfigLineToQueue`;
    return this.http.post<any>(url, payload, formHeaders).pipe(
      map(data => {
        return data;
      }), catchError(err => {
        return of(false);
      })
    );
  }

  postRulesQueue(payload: any) {
    const formHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const url = `${AppSettings.API_URI}/AddmodifyTimeRangesToQueue`;
    return this.http.post<any>(url, payload, formHeaders).pipe(
      map(data => {
        return data;
      }), catchError(err => {
        return of(false);
      })
    );
  }

  getPendingInQueue(id: string) {
    let url = '';
    if (id.includes('.')) {
      url = AppSettings.API_URI + '/pendingQueue?address=' + id;
    } else {
      url = AppSettings.API_URI + '/pendingQueue?phone_line=' + id;

    }
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  executeFromQueue(id: string) {
    let url = AppSettings.API_URI + '/executeQueue/' + id;
    return this.http.put<any>(url, {}).pipe(
      map(data => {
        return data;
      })
    );
  }

  cancelFromQueue(id: string) {
    let url = AppSettings.API_URI + '/cancelQueue/' + id;
    return this.http.put<any>(url, {}).pipe(
      map(data => {
        return data;
      })
    );
  }

  getQueueById(id: string) {
    let url = AppSettings.API_URI + '/getQueuebyId/' + id;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getLineInfo(phone: string) {
    let url = AppSettings.API_URI + '/line-configuration?phone_number=' + phone;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  createAlias(payload: any) {
    let url = AppSettings.API_URI + '/lineAlias';
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  getShortNumber(phone: string) {
    let url = AppSettings.API_URI + '/lineShortNumber?public_number=' + phone;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  createShortNumber(payload: any) {
    let url = AppSettings.API_URI + '/shortNumber';
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  deleteShortNumber(id: string) {
    let url = AppSettings.API_URI + '/shortNumber/' + id;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getConsumptionOptions() {
    let url = AppSettings.API_URI + '/consumption-option';
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getConsumptionById(id: string) {
    let url = AppSettings.API_URI + '/consumption-option/' + id;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  postConsumptionPreferences(payload: any) {
    let url = AppSettings.API_URI + '/consumption';
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  getBaseConfigurations() {
    let url = AppSettings.API_URI + '/base-configuration';
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  postProfileConfiguration(payload: any) {
    let url = AppSettings.API_URI + '/configuration-profile';
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  putProfileConfiguration(id: string, payload: any) {
    let url = AppSettings.API_URI + '/configuration-profile/' + id;
    return this.http.put<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  getProfilesByUser(fiscal_id: string) {
    let url = AppSettings.API_URI + '/user/configuration-profile/' + fiscal_id;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getProfileById(id: string) {
    let url = AppSettings.API_URI + '/configuration-profile/' + id;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  deleteProfile(id: string) {
    let url = AppSettings.API_URI + '/configuration-profile/' + id;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  postUser(payload: any) {
    let url = AppSettings.API_URI + '/users';
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  updateProfileLines(id: string, payload: any) {
    let url = AppSettings.API_URI + '/configuration-profile/lines/' + id;
    return this.http.put<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  getGroups(fiscal_id: string) {
    let url = AppSettings.API_URI + '/user/line-group/' + fiscal_id;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  createGroup(payload: any) {
    let url = AppSettings.API_URI + '/line-group';
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  deleteGroup(id: string) {
    let url = AppSettings.API_URI + '/line-group/' + id;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  updateGroup(id: string, payload: any) {
    let url = AppSettings.API_URI + '/line-group/' + id;
    return this.http.put<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  updateGroupLines(id: string, payload: any) {
    let url = AppSettings.API_URI + '/line-group/lines/' + id;
    return this.http.put<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  addLineRules(payload: any) {
    let url = AppSettings.API_URI + '/line-extra-configuration';
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  getSims() {
    let url = AppSettings.API_URI + '/line-sims/pool';
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  

  updateLineSim( payload: any) {
    let url = AppSettings.API_URI + '/line-sims';
    return this.http.put<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  blockSim(pipeline: any) {
    let url = AppSettings.API_URI + '/line-sims/block';
    return this.http.put<any>(url, pipeline).pipe(
      map(data => {
        return data;
      })
    );
  }

  unblockSim(pipeline: any) {
    let url = AppSettings.API_URI + '/line-sims/unblock';
    return this.http.put<any>(url, pipeline).pipe(
      map(data => {
        return data;
      })
    );
  }

  getLineConfigurationInfo(phone: string) {
    let url = AppSettings.API_URI + '/line/configuration-info?phone_number=' + phone;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  getUserByFiscalId(fiscal_id: string) {
    let url = AppSettings.API_URI + '/getUserByFiscalId?fiscal_id=' + fiscal_id;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  updateUser(payload: any, id: number) {
    let url = AppSettings.API_URI + '/updateUser/' + id;
    return this.http.put<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  getFixedLines(perPage: number, page: number, fiscal_id: string,){
    let url = AppSettings.API_URI + '/isp-lines?fiscal_id=' + fiscal_id + '&page=' + page + '&num=' + perPage;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  createRedirection(payload: any) {
    let url = AppSettings.API_URI + '/redirection';
    return this.http.post<any>(url, payload).pipe(
      map(data => {
        return data;
      })
    );
  }

  getLineRedirection(phone: string) {
    let url = AppSettings.API_URI + '/redirection?destination_number=' + phone;
    return this.http.get<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }

  deleteRedirection(id: string) {
    let url = AppSettings.API_URI + '/redirection/' + id;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }
}
